import Alerts from "@/api/Alerts";

export const alerts = {
    state: () => ({
    }),
    mutations: {
    },
    getters: {
    },
    actions: {
        async getAlerts(params) {
            return new Promise((resolve, reject) => {
                Alerts.getAlerts()
                    .then(response => {
                        resolve(response);
                    }).catch(err => {
                        reject(err);
                    });
            });
        },
    }
}